import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '../api';

const SYMBOLS = { INR: '₹', KWD: 'KD ', USD: '$', AED: 'AED ', EUR: '€', GBP: '£', SAR: 'SAR ' };
const DECIMALS = { KWD: 3 };

const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState(() => localStorage.getItem('currency') || 'INR');
  const [rates, setRates] = useState({ INR: 1 });

  useEffect(() => {
    api.get('/currencies').then((res) => setRates(res.data.rates)).catch(() => {});
  }, []);

  const setCurrency = useCallback((c) => { localStorage.setItem('currency', c); setCurrencyState(c); }, []);

  const format = useCallback((inr) => {
    const rate = rates[currency] ?? 1;
    const value = (Number(inr) || 0) * rate;
    const digits = DECIMALS[currency] ?? 0;
    return `${SYMBOLS[currency] || currency + ' '}${value.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
  }, [currency, rates]);

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, rates, format, currencies: Object.keys(rates) }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);

export const Price = ({ inr, className = '', testId }) => {
  const { format } = useCurrency();
  return <span className={className} data-testid={testId}>{format(inr)}</span>;
};
